import React, { useContext } from 'react';
import { Link, Redirect } from 'react-router-dom';
import RootContext from '../../context';
import { PATH_INTRO, PATH_ROOT } from '../../paths';
// import { StandartPage } from '../../design/StandartPage';
// import timeout from '../../../assets/timeout.svg';
// import { PermissionButton, WhiteButton } from '../NoPermission/styles';
// import { Container } from '../../design/Container';
// import { sendMessageToParent } from '../../utils';

export const NoTimeLeft = () => {
  const { videoParams } = useContext(RootContext);
  if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;

  // const underText = <ul style={{ marginLeft: '-20px' }}>
  //   <li>Try to match your head points to the frame in 5 seconds</li>
  //   <li>Do not leave the frame to check liveness successfully</li>
  // </ul>;
  //
  // const buttons = <Container>
  //   <WhiteButton onClick={() => sendMessageToParent({ _: 'cancel' })}>
  //     cancel
  //   </WhiteButton>
  //   <Link to={`${PATH_ROOT}${PATH_INTRO}`}>
  //     <PermissionButton>
  //       TRY AGAIN
  //     </PermissionButton>
  //   </Link>
  // </Container>;

  return (
    <>
      no time left
    </>
  );
};

/*
      <StandartPage
        image={timeout}
        title={'Ooops! Seems like you’re out of time'}
        underText={underText}
        buttons={buttons}
      />
 */
